
/* eslint-disable max-len */
import { pascalCase } from 'change-case';
import React, { useCallback } from 'react';
import { LFC } from '../../../Legacy';
import { Icon } from '../../../concepts/resources/Icon';
import { Cell, Colors, Grid } from '../../../ui';
import { DropButton } from '../../../ui/DropButton';
import { GridButton } from '../../../ui/GridButton';
import { Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { PollType } from '../../packages/polling/PollTypes';

const type = (id: PollType, label: string, desc: string, icon: string) => ({ id, label, desc, icon });
const types = [
    type(
        'single',
        'Single Choice',
        'Provide multiple options but only allow participants to select a single answer.',
        'deqo://icons/meeting/poll-single'
    ),
    type(
        'multi',
        'Multiple Choice',
        'Provide multiple options and allow participants to select multiple answers.',
        'deqo://icons/meeting/poll-multi'
    ),
    type(
        'scale',
        'Number Scale',
        'Ask a question that requires a number answer, e.g. score out of 10.',
        'deqo://icons/meeting/poll-scale'
    ),
];


// type ResultCallback = (value: 'exit' | PollType) => void;

// export const SetupPollTypeView: LFC<{ onResult: ResultCallback }> = ({ onResult }) => {
//     return <Prompt ignoreMouse ignoreEnter onAction={() => onResult('exit')}>
//         <FadeIn>
//             <Popup.Title>Pick your poll:</Popup.Title>
//             {options.map(o =>
//                 <Flexer key={o.id} padding="0 0 .5 0">
//                     <BigButton onClick={() => onResult(o.id)}>
//                         <BigButton.Inner>
//                             <BigButton.Icon color={o.color}>
//                                 <Icon size="2" src={o.icon} />
//                             </BigButton.Icon>
//                         </BigButton.Inner>
//                         <BigButton.Inner expand>
//                             <Title size="md">{o.label}</Title>
//                             <Copy>{o.desc}</Copy>
//                         </BigButton.Inner>
//                     </BigButton>
//                 </Flexer>
//             )}
//         </FadeIn>
//     </Prompt>;
// };

export const SetupPollTypeSlide: LFC<{ onSelect: (path: string) => void }> = ({ onSelect }) => {

    const onChoose = useCallback((t: PollType) => onSelect(`menu/poll/${t}`), [onSelect]);
    const onBack = useCallback(() => onSelect('menu'), [onSelect]);

    return <Flexer height="100%" padding="2 1" gap=".5" flex="column" align="center">
        <Flexer gap=".375" flex="row" center>
            <Icon src="deqo://icons/meeting/poll" size="2" />
            <Title size="lg" flush>Run Poll</Title>
        </Flexer>
        <Flexer flex="column" center>
            <Copy flush>
                Which type of poll would you like to run?
            </Copy>
        </Flexer>
        <Flexer padding=".5 8">
            <Grid columns="1fr" rowGap="1rem">
                {types.map(t =>
                    <Cell key={t.id}>
                        <GridButton data-action={`editor.hostMenu.polls.open${pascalCase(t.id)}`} onClick={() => onChoose(t.id)}>
                            <GridButton.Top color={Colors.primary}>
                                <GridButton.Icon color={Colors.primary}>
                                    <Icon size="2.4" src={t.icon} />
                                </GridButton.Icon>
                                <Title>{t.label}</Title>
                            </GridButton.Top>
                            <Copy>{t.desc}</Copy>
                        </GridButton>
                    </Cell>
                )}
            </Grid>
        </Flexer>
        <Flexer>
            <DropButton padding=".125 .375" onClick={onBack}>
                <Icon src="deqo://icons/hero/arrow-sm-left" size="1.5" />
                <Title weight="450" flush>Go Back</Title>
            </DropButton>
        </Flexer>
    </Flexer>;
};
